<template>
<div>
    <div class="mcc-page-header mu-d-flex">
        <section class="mu-d-flex mu-w-100 mu-justify-content-between mu-align-items-center">
            <div class="mu-d-flex  mu-align-items-center">
                <h1 class="mu-mb-00">Import/Export details</h1>
                <details class="mcc-popover mcc-popover--bottom-end">
                    <summary class="mcc-button mcc-button--icon-only ">
                        <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                    </summary>
                    <div class="mcc-popover__content">
                        <p class="mu-mb-00">
                            {{ helpText.title }}
                            <a :href="helpText.url" target="_blank" class="linkCode">Read more...</a>
                        </p>
                    </div>
                </details>
            </div>
            <div role="group" class="mcc-button-group mcc-button-group--spaced">
                <button class="mcc-button mcc-button--outline" title="Export" @click="showExport" :disabled="importInProgress">
                    <mcc-icon name="export" aria-hidden="true"></mcc-icon><span class="mcc-button__label ">Export</span>
                </button>
                <button class="mcc-button mcc-button--outline" title="Upload" @click="showDropzone" :disabled="importInProgress">
                    <mcc-icon name="upload_2" aria-hidden="true"></mcc-icon>
                    <span class="mcc-button__label ">Upload</span>
                </button>
            </div>
        </section>
    </div>
    <div class="mcc-container-fluid card-padding">
        <nav aria-label="breadcrumb">
            <ol class="mcc-breadcrumb">
                <li>Administration</li>
                <li>Import/Export</li>
            </ol>
        </nav>
        <div class="mcc-card">
            <div v-if="responseListLoading && !importInProgress" class="spinner-overlay">
                <div class="spinner-background"></div>
                <div class="spinner-flex ">
                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                    </svg>
                </div>
            </div>
            <div class="mcc-card__header">
                <div class="mu-d-flex mu-justify-content-end mu-pb-06">
                    <div role="group" class="mcc-button-group mcc-button-group--spaced">
                        <button class="mcc-button mcc-button--outline mcc-button--sm" id="refreshBtn" @click="resetContent()" title="Refresh">
                            <mcc-icon name="refresh" aria-hidden="true"></mcc-icon><span class="mcc-button__label ">Refresh</span>
                        </button>
                        <button class="mcc-button mcc-button--outline mcc-button--sm" @click="$refs.customFilter.open()" title="Filters">
                            <mcc-icon name="filter" aria-hidden="true"></mcc-icon>
                            <span class="mcc-button__label ">Filters{{ filterCount > 0 ? '(' + filterCount + ')' : '' }}</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="mcc-card__body mu-pb-06 mu-mt-03">
                <Drawer ref="customFilter" @reset-filter="resetFilter" @apply-filter="filterTable()" title="Import/Export Filters">
                  
                        <div class="mcc-card mu-border-0">
                            <div v-if="dataCall" class="spinner-overlay">
                                <div class="spinner-background"></div>
                                <div class="spinner-flex ">
                                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5">
                                        </circle>
                                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    </svg>
                                </div>
                            </div>
                            <div v-show="!dataCall">
                                <form id="formIdd">
                                <div class="mfc-slim-select-wrapper drawer-input">
                                    <label for="user-selectId">Username</label>
                                    <select id="user-selectId" @change="setSelectedUsers" name="userSelect" ref="selectedUserRef" block multiple>
                                        
                                        <option v-for="label in userList" :key="label.id" :selected="selectedUsers.indexOf(label.id) > -1" :value="label.id">{{label.firstName}}</option>
                                    </select>
                                </div>
                                </form>
                            </div>
                        </div>
                  
                </Drawer>
                <div class="mcc-col" v-if="fetchCall">
                    <div style="position: relative;">
                        <div v-if="importInProgress" class="spinner-overlay zIndex10">
                            <div class="spinner-background"></div>
                            <div class="spinner-flex spinner-text">
                                <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                    <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                </svg>
                                <span class="font-weight-bold"> Another Import/Export process is currently executing. please wait till it completes.</span>
                            </div>
                        </div>
                        <mcc-data-table ref="importExportTable" id="importExportTableId"></mcc-data-table>
                    </div>
                </div>
            </div>

            <div class="mcc-dialog-overlay">
                <dialog class="mcc-dialog mcc-dialog--info mcc-dialog--sm" v-show="fetchCall" ref="failureRecords" id="failureRecordsId">
                    <section>
                        <div class="mcc-dialog__header">
                            <h2 class="h4">Failure details</h2>
                            <button class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="closeJSTree()">
                                <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                                <span class="mcc-button__label">Button</span>
                            </button>
                        </div>
                        <div class="mcc-dialog__body">
                            <div class="mcc-row">
                                <div class="mcc-col">
                                    <div class="JSTreeDiv" id="failureResponse" tabindex="-1"></div>
                                </div>
                            </div>
                        </div>
                        <div class="mcc-dialog__footer">
                            <div class="mcc-button-group mcc-button-group--spaced">
                                <button type="button" class="mcc-button mcc-button--info" @click="closeJSTree()">Close</button>
                            </div>
                        </div>
                    </section>
                </dialog>
            </div>
            <div class="mcc-dialog-overlay">
                <dialog class="mcc-dialog mcc-dialog--warning mcc-dialog--xs" ref="validateExportFileDialog" id="validateExportFileDialog">
                    <form novalidate @submit.prevent="submitValidateExportDialog()">
                        <section>
                            <div class="mcc-dialog__header">
                                <h2 class="h4">Warning!</h2>
                                <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="closeValidateExportDialog(true)">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                            </div>
                            <div class="mcc-dialog__body">
                                <div class="mcc-row">
                                    <div class="mcc-col">
                                        <div v-if="validateDialog">
                                            <div class="mt-2">
                                                <div class="textAlignJustify">
                                                    The application(s)/form(s)/process(es) already exists, proceeding with this import will override them. Do you still want to continue?
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="mcc-dialog__footer">
                                <div class="mcc-button-group mcc-button-group--spaced">
                                    <button type="button" class="mcc-button mcc-button--outline" @click="closeValidateExportDialog(true)">No</button>
                                    <button type="submit" class="mcc-button mcc-button--warning">Yes</button>
                                </div>
                            </div>
                        </section>
                    </form>
                </dialog>
            </div>
        </div>
    </div>
    <div class="mcc-dialog-overlay" v-show="dropzoneOpen" id="fileUploadCard">
        <dialog class="mcc-dialog mcc-dialog--primary mcc-dialog--xs" ref="uploadDialog">
            <form novalidate @submit.prevent="uploadFiles($event)" id="MyForm">
                <div class="mcc-dialog__header">
                    <h4 class="h4">Upload files</h4>
                    <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="closeDropzone">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body">
                    <mcc-alert role="alert" class="mcc-alert  mcc-alert mcc-alert--danger" v-show="showWarning">
                        <mcc-icon name="stop_sign" aria-hidden="true"></mcc-icon>
                        <div class="mu-fw-semi-bold">Please upload at least one file in dropzone</div>
                    </mcc-alert>
                    <mfc-file-upload name="files" maxfiles="6" :filetypes="JSON.stringify(['csv','zip'])" maxfilesize="10" required options="{&quot;url&quot;:&quot;/tasks-api/add-attachment&quot;,&quot;acceptedFiles&quot;:&quot;.zip,.csv&quot;,&quot;addRemoveLinks&quot;:true,&quot;uploadMultiple&quot;:true,&quot;autoProcessQueue&quot;:false,&quot;paramName&quot;:&quot;files&quot;,&quot;maxFiles&quot;:6,&quot;parallelUploads&quot;:10}">
                    </mfc-file-upload>  
                </div>
                <div class="mcc-dialog__footer">
                    <div role="group" class="mcc-button-group mcc-button-group--spaced">
                        <button type="button" class="mcc-button mcc-button--outline" title="Close" @click="closeDropzone">
                            <span class="mcc-button__label">Close</span>
                        </button>
                        <button type="submit" class="mcc-button mcc-button--primary" title="upload">
                            <span class="mcc-button__label">Upload</span>
                        </button>
                    </div>
                </div>
            </form>
        </dialog>
    </div>
    <div class="mcc-dialog-overlay" v-show="fetchCall">
        <dialog class="mcc-dialog mcc-dialog--primary mcc-dialog--xs" v-show="exportDialogOpen" ref="exportDialog">
            <section>
                <div class="mcc-dialog__header">
                        <h4 class="mcc-dialog__title">Export</h4>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="hideExportDialog">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body">
                    <form novalidate>
                        <div class="mcc-row">
                            <div class="mcc-col">
                                <div class="mfc-checkbox-wrapper mu-d-block mfc-form-input-container">
                                    <input type="checkbox" value="All" name="allExport" :checked="selectedEntity.length>0 && selectedEntity.length==exportEntities.length" @change="updateSelectAll($event)">
                                    <label for="All">All</label>
                                </div>
                                <span v-for="(obj,key) in exportEntities" :key="key">
                                    <div v-if="key <= 5" class="mfc-checkbox-wrapper mu-d-block mfc-form-input-container mu-mt-05">
                                        <input type="checkbox" class="export" name="export" @change="updateSelect($event,obj.value)" :label="obj.name" :value="obj.value">
                                        <label for="export">{{ obj.name }}</label>
                                    </div>
                                </span>
                            </div>
                            <div class="mcc-col">
                                <span v-for="(obj,key) in exportEntities" :key="key">
                                    <div v-if="key > 5" class="mfc-checkbox-wrapper mu-d-block mfc-form-input-container" :class="{'mu-mt-05': key > 6}">
                                        <input type="checkbox" class="export" name="export" @change="updateSelect($event,obj.value)" :label="obj.name" :value="obj.value">
                                        <label for="export">{{ obj.name }}</label>
                                    </div>
                                </span>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="mcc-dialog__footer">
                    <div role="group" class="mcc-button-group mcc-button-group--spaced">
                        <button class="mcc-button mcc-button--outline" title="Close" @click="hideExportDialog">
                            <span class="mcc-button__label">Close</span>
                        </button>
                        <button class="mcc-button mcc-button--primary" @click="exportMultipleApplications()" v-if="selectedEntity.length == 1 && selectedEntity[0] == 'APPLICATION'" id="exportMultiAppBtn" title="Multi zip">
                            <span class="mcc-button__label">Multi zip</span>
                        </button>
                        <button class="mcc-button mcc-button--primary" @click="exportFiles()" v-if="selectedEntity.length == 1 && selectedEntity[0] == 'APPLICATION'" id="exportSingleZipBtn" title="Single zip">
                            <span class="mcc-button__label">Single zip</span>
                        </button>
                        <button class="mcc-button mcc-button--primary" @click="exportFiles()" v-if="!(selectedEntity.length == 1 && selectedEntity[0] == 'APPLICATION')" :disabled="selectedEntity.length==0" id="exportBtn" title="Export">
                            <span class="mcc-button__label mu-text-inverse">Export</span>
                        </button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>
</div>
</template>

<script>
import ImportExportAPI from "../../../services/ImportExportAPI";
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import constants from "../../../constants";
import Utils from "@/script_utils";
import MyTaskListAPI from "../../../services/MyTaskListAPI";
import CSSLoader from "../../../loadCss";
import Drawer from '../../common/Drawer.vue';
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';
export default {
    name: "importexport",
    components: {
        Drawer
    },

    data() {
        return {
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            helpText: constantMessages.BREADCRUMB_HELP["importexport"],
            dataLoaded: false,
            fetchCall: false,
            showData: false,
            dropzoneObj: null,
            selectedEntity: [],
            userList: [],
            dataCall: false,
            selectedUsers: "",
            userSelect: "",
            currentPageSize: 10,
            tableObj: null,
            selectInstanceUsername: null,
            filterCount: 0,
            filterActive: false,
            filterData: [],

            tableData: [],

            exportEntities: [{
                name: "Groups",
                value: "GROUP"
            }, {
                name: "Users",
                value: "USER"
            }, {
                name: "External systems",
                value: "EXTERNALSYSTEM"
            }, {
                name: "Hierarchies",
                value: "HIERARCHYCHART"
            }, {
                name: "User properties",
                value: "USERPROPERTY"
            }, {
                name: "Group hierarchy structure",
                value: "GROUPHIERARCHYSTRUCTURE"
            }, {
                name: "Applications",
                value: "APPLICATION"
            }, {
                name: "Process categories",
                value: "PROCESSCATEGORY"
            }, {
                name: "Email templates",
                value: "EMAILTEMPLATE"
            }, {
                name: "Form templates",
                value: "FORMTEMPLATE"
            }, {
                name: "Global process properties",
                value: "GLOBALPROCESSPROPERTIES"
            }, {
                name: "System templates",
                value: "SYSTEMTEMPLATE"
            }],
            importInProgress: false,
            responseListLoading: false,
            selectedUsersLoaded: false,
            validateDialog: false,
            validatedData: null,
            callResetFunction: true,
            dropzoneOpen: false,
            showWarning: false,
            exportDialogOpen: false,
            fileIsValid: true,
        };
    },
    mounted() {
        CSSLoader.load("/webjars/jstree/3.3.8/themes/default/style.min.css");
        Utils.applyFixedHeaderConfiguration(this);
        let self = this;
        self.fetchCall = true;
        if (localStorage.getItem("auditList") == "auditList") {
            this.selectedUsers = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_username"
            );
            this.userSelect = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_username"
            );
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_username"
            );
            this.currentPageSize = parseInt(
                localStorage.getItem("auditListPageSize")
            );
            localStorage.removeItem("auditListPageSize");

            localStorage.removeItem("auditList");
            this.filterCount = parseInt(
                localStorage.getItem("auditListFilterCount")
            );
            localStorage.removeItem("auditListFilterCount");
        }
        self.waitDropzoneShown();
        self.updateImportStatus();
        MyTaskListAPI.getUsers().then(result => {
            self.userList = result;
            self.selectedUsersLoaded = true;
        });
        this.selectInstanceUsername = new SlimSelect({
            select: '#user-selectId',
            settings: {
            closeOnSelect: false,
             },
        })
    },
    methods: {
        showExport() {
            this.exportDialogOpen = true;
            this.$refs.exportDialog.show();
        },
        hideExportDialog() {
            this.selectedEntity = [];
            this.exportDialogOpen = false;
            $(".export").each(function (index, ele) {
                ele.checked = false;
            });
            this.$refs.exportDialog.close();
        },
        showDropzone() {
            this.showWarning = false;
            this.dropzoneOpen = true;
            this.$refs.uploadDialog.show();
        },
        closeDropzone() {
            this.dropzoneOpen = false;
            document.querySelector("mfc-file-upload .dropzone")?.dropzone.removeAllFiles();
            this.$refs.uploadDialog.close();
        },
        getFilterCount() {
            if (this.selectedUsers != "")
                this.filterCount += 1
        },
        filterImportExportResponse(e) {
            e.detail.instance.close();
            this.initImportExportTable();
        },
        filterTable() {
            this.filterCount = 0;
            this.userSelect = this.selectInstanceUsername.getSelected();
            this.getFilterCount();
            this.initImportExportTable();
            $('#formIdd').closest('#drawerOverlay').removeClass("mcc-drawer--open")
            $('#formIdd').closest('#drawerOverlay').addClass("mcc-drawer--closed")
        },
        resetFilter() {
            this.selectedUsers = "";
            this.userSelect = "";
            this.filterCount = 0;
            this.$refs.selectedUserRef.value = [];
            this.selectInstanceUsername.setSelected('');
            this.initImportExportTable();
        },
        updateImportStatus() {
            let self = this;
            ImportExportAPI.getImportExportStatus()
                .then(response => {
                    self.importInProgress = response.error;
                });
        },
        resetContent(error) {
            let self = this;
            self.selectedEntity = [];
            document.querySelector("mfc-file-upload .dropzone").dropzone.removeAllFiles();
            $(" [name=export]").each(function (index, ele) {
                ele.checked = false;
            });
            $("[name=allExport]").prop("checked", false);
            ImportExportAPI.getImportExportStatus()
                .then(response => {
                    const temp = self.importInProgress;
                    self.importInProgress = response.error;
                    if(temp === true && self.importInProgress === false && !error && this.fileIsValid) {
                        EventBus.$emit("success-notification", {
                            msg: "Your file has been successfully uploaded."
                        });
                    }
                    this.resetFilter();
                });
        },
        uploadFiles(e) {
            let self = this;
            let formDataArray = $('#MyForm').serializeArray();
            let form_data = new FormData();
            const dropzone = document.querySelector("mfc-file-upload .dropzone").dropzone;
            if(dropzone.files.length === 0) {
                self.showWarning = true;
                return;
            }
            if (Utils.appendDropzoneData(form_data, dropzone)) {
                self.importInProgress = true;
                self.validatedData = form_data;
                ImportExportAPI.validateExportFiles(form_data)
                    .then(response => {
                        if (response == undefined) {
                            this.closeValidateExportDialog(true);
                        } else if (response != undefined && response.data === true) {
                            this.showExportDialog();
                        } else {
                            this.uploadValidatedFiles();
                        }
                    });
            }
            self.closeDropzone();
        },
        exportFiles() {
            let self = this;

            if (self.selectedEntity.length > 0) {

                let queryStr = constants.BASE_URL + `/imports-exports/exports`;
                $.each(self.selectedEntity, function (key, value) {
                    if (key == 0) {
                        queryStr += "?filetype[]=" + value;
                    } else {
                        queryStr += "&filetype[]=" + value;
                    }
                });
                const link = document.createElement('a');
                link.href = queryStr;
                link.click();
            }
        },
        validateExportDialog() {
            this.validateDialog = true;
        },
        showExportDialog() {
            this.callResetFunction = true;
            this.$refs.validateExportFileDialog.show();
            this.validateExportDialog()
        },
        closeValidateExportDialog(error) {
            this.validateDialog = false;
            if (this.callResetFunction) {
                this.resetContent(error);
            }
            this.$refs.validateExportFileDialog.close();
        },
        submitValidateExportDialog() {
            this.callResetFunction = false;
            this.uploadValidatedFiles();
            this.$refs.validateExportFileDialog.close();
        },
        uploadValidatedFiles() {
            ImportExportAPI.uploadFiles(this.validatedData)
                .then(response => {
                    if (response.error) {
                        this.fileIsValid = false;
                        EventBus.$emit("error-notification", {
                            msg: constantMessages.MESSAGES[response.message]
                        });
                    }
                    else {
                        this.fileIsValid = true;
                    }
                });
        },
        async waitDropzoneShown() {
            await this.$nextTick();
            let self = this;
            self.initImportExportTable();
        },
        setSelectedUsers() {
            let self = this;
            self.selectedUsers = this.selectInstanceUsername.getSelected();
            if (self.selectedUsers.length > 0) {
                self.selectedUsers = self.selectedUsers.split(",");
                queryString += "&username=" + self.selectedUsers;
            }
        },
        exportMultipleApplications() {
            this.$router.push(
                this.CONTEXT_PATH + "/design/applications"
            );
        },
        updateSelect(event) {
            let self = this;
            if (event.target.checked) {
                self.selectedEntity.push(event.target.value);
            } else {
                self.selectedEntity.splice(self.selectedEntity.indexOf(event.target.value), 1);
            }
            $("[name=allExport]").prop("checked", self.selectedEntity.length == self.exportEntities.length);
        },
        updateSelectAll(event) {
            let self = this;
            self.selectedEntity = [];
            $(".export").each(function (index, ele) {
                if (event.target.checked) {
                    self.selectedEntity.push(ele.value);
                }
                ele.checked = event.target.checked;
            });
        },
        updateTemplate() {
            let self = this;
            $(".failureRecords").each((a, obj) => {
                let message = $(obj)[0].innerText;
                let id = $(obj).attr("data-id");
                if (message === "COMPLETED_WITH_ERRORS") {
                    message = '<a class="linkCode" data-id="' + id + '">' + ' View details </a>'
                } else if (message === "FILE_NOT_SUPPORTED") {
                    message = "FILE NOT SUPPORTED";
                } else {
                    message = "NO ERROR";
                }
                $(obj).html(message);
            });
            this.$refs.importExportTable
                .querySelectorAll('td [class="linkCode"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        let targetEle = e.target;
                        if (targetEle != null) {
                            self.setFilterDataInLocalStorage();
                            this.showFileTree($(targetEle).attr("data-id"));
                        }
                    });
                });
        },
        showFileTree(id) {
            let self = this;
            self.responseListLoading = true;
            ImportExportAPI.getFailureData(id)
                .then(response => {
                    self.responseListLoading = false;
                    this.$refs.failureRecords.show();
                    $("#failureResponse").jstree({
                        "plugins": ["json_data"],
                        core: {
                            'data': response
                        }
                    });
                    $("#failureResponse").attr("tabindex", "-1");
                });
        },
        closeJSTree() {
            $('#failureResponse').jstree('destroy');
            this.$refs.failureRecords.close()
        },
        initImportExportTable() {
            let self = this;
            if (self.responseListLoading) {
                return;
            }
            if (this.tableObj != null) {
                this.currentPageSize = this.tableObj.tableContext.store.state.pageSize;
            }
            const filesTable = document.querySelector('#importExportTableId');
            self.tableObj = window.tableFactory.create(filesTable, {
                bordered: true,
                striped: true,
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                pageSize: self.currentPageSize,
                debounceTime: 1000,
                emptyStatusRecords: {
                    icon: 'empty_folder',
                    title: 'No import/export response found ',
                },
                fixedHeight: true,
                schema: {
                    properties: {
                        fileTimeStamp: {
                            type: "string",
                            title: "Uploaded",
                            sortable: true,
                            template: '<div class="dateTemplate"><u>{{date}}</u><div>{{fileTimeStampString}}</div></div>',
                            columnSearch: false
                        },
                        importFileName: {
                            type: "string",
                            title: "Filename",
                            sortable: true,
                            columnSearch: false
                        },
                        message: {
                            type: "string",
                            title: "Message",
                            sortable: false,
                            columnSearch: false
                        },
                        successMessage: {
                            type: "string",
                            title: "Success message",
                            sortable: false,
                            columnSearch: false
                        },
                        status: {
                            type: "string",
                            title: "Failure records",
                            template: '<div class="failureRecords" data-id="{{id}}">{{status}}</div>',
                            sortable: false,
                            columnSearch: false
                        },
                        username: {
                            type: "string",
                            title: "Imported by",
                            sortable: false,
                            columnSearch: false
                        }

                    }
                },
                data: (
                    start,
                    limit,
                    sortHeader,
                    sortDirection,
                    fullTextQuery,
                    searchColumns
                ) => {
                    if (!self.filterActive) {
                        self.responseListLoading = true;
                        if (self.tableObj != null) {
                            self.currentPageSize =
                                self.tableObj.tableContext.store.state.pageSize;
                        }
                        if (sortHeader == null || sortHeader == "fileTimeStamp") {
                            sortHeader = "asyncProcess.createdDate"
                        }
                        if (sortDirection == null) {
                            sortDirection = "desc"
                        }

                        let queryString =
                            "start=" +
                            start +
                            "&length=" +
                            self.currentPageSize +
                            "&sort=" +
                            sortHeader +
                            "&dir=" +
                            sortDirection;
                        if (self.selectedUsers != "") {
                            queryString += "&username=" + self.selectedUsers;
                        }

                        return ImportExportAPI.getImportExportData(queryString).then(result => {
                            self.responseListLoading = false;
                            let responseData = {
                                totalCount: 0,
                                data: []
                            };
                            responseData.totalCount = result.page.totalElements;
                            if (result.data != null) {
                                result.data.forEach(item => {
                                    item['fileTimeStampString'] = item['fileTimeStamp'] != null ?
                                        Utils.getMomentDateString(item['fileTimeStamp']) : ''
                                });
                                responseData.data = result.data;
                            }
                            self.tableData = responseData.data;
                            return responseData;
                        });
                    } else {
                        self.filterActive = false;
                        let responseData = {
                            totalCount: self.filterData.length,
                            data: self.filterData
                        };
                        return responseData;
                    }
                },
                onPageChange: (start, limit) => {
                    self.updateTemplate();
                }
            });
        },
        setFilterDataInLocalStorage() {
            localStorage.setItem("auditListPageSize", this.tableObj.tableContext.store.state.pageSize);

            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_username",
                this.userSelect
            );
            localStorage.setItem("auditListFilterCount", this.filterCount);
        }
    }
}
</script>
